import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { CustomerCreateForm } from '../../modules/customers/customer-create-form.js';

export const Route = createFileRoute('/customers/new')({
  component: NewCustomerPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewCustomerPage() {
  return (
    <RouteGuard route="/customers/new">
      <div>
        <CustomerCreateForm />
      </div>
    </RouteGuard>
  );
}
